import React from 'react';
import { Icon } from '../../../SvgIcon';

interface Props {
  width?: number;
  height?: number;
}

export const ShiPinHao = (props: Props) => {
  const { width = 20, height = 20 } = props;

  return <Icon name="shipinghao" width={width} height={height} />;
};
